import i18n from '../plugins/i18n';
import * as dayjs from "dayjs";
require('dayjs/locale/th');
const buddhistEra = require('dayjs/plugin/buddhistEra')
dayjs.extend(buddhistEra)

export function objectTranslator(object, prefix) {
    let lang_suffix = '';
    if (this.$root.$i18n.locale === 'en') lang_suffix = '_EN';
    else if (this.$root.$i18n.locale === 'th') lang_suffix = '_TH';
    else return 'Language not available';
    return object[prefix + lang_suffix];
}

export function objectTranslatorLowerCase(object, prefix) {
    let lang_suffix = '';
    if (this.$root.$i18n.locale === 'en') lang_suffix = '_en';
    else if (this.$root.$i18n.locale === 'th') lang_suffix = '_th';
    else return 'Language not available';
    return object[prefix + lang_suffix];
}


export function inlineTranslator(dict) {
    if (i18n.locale === 'en' && !!dict.en) return dict.en;
    else if (i18n.locale === 'th' && !!dict.th) return dict.th;
    else return 'Language service not available';
}
export function getLevelName(level) {
    if (i18n.locale === 'en') {
        if (parseInt(level) === 1) return 'Bachelor';
        else if (parseInt(level) === 2) return 'Master';
        else if (parseInt(level) === 3) return 'Doctor';
    }
    else if (i18n.locale === 'th') {
        if (parseInt(level) === 1) return 'ปริญญาตรี';
        else if (parseInt(level) === 2) return 'ปริญญาโท';
        else if (parseInt(level) === 3) return 'ปริญญาเอก';
    }
    return 'no "LEVEL" data available';
}

export function dateFromDBTranslator(date) {
    if (i18n.locale === 'en') return dayjs(date, "YYYY-MM-DD").locale('en').format('D MMM YYYY');
    else if (i18n.locale === 'th') return dayjs(date, "YYYY-MM-DD").locale('th').format('D MMM BBBB');
    else return 'Language service not available';
}

export function dateFromDBTranslatorFull(date) {
    if (i18n.locale === 'en') return dayjs(date, "YYYY-MM-DD").locale('en').format('D MMMM YYYY');
    else if (i18n.locale === 'th') return dayjs(date, "YYYY-MM-DD").locale('th').format('D MMMM BBBB');
    else return 'Language service not available';
}

export function dateFromDBTranslatorTH(date) {
 return dayjs(date, "YYYY-MM-DD").locale('th').format('D MMMM BBBB');
}

export function dateFromDBTranslatorEN(date) {
    return dayjs(date, "YYYY-MM-DD").locale('en').format('D MMMM YYYY');
}

export function formatNumber(num) {
    if (i18n.locale === 'en') {
        if (num) return Number(num).toLocaleString()+" Baht";
        else return '-';
    }else{
        if (num) return Number(num).toLocaleString()+" บาท";
        else return '-';
    }
}

export function dateTimeFromDBTranslatorFull(date) {
    if (i18n.locale === 'en') return dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('en').format('D MMMM YYYY HH:mm:ss');
    else if (i18n.locale === 'th') return dayjs(date, "YYYY-MM-DD HH:mm:ss").locale('th').format('D MMMM BBBB HH:mm:ss');
    else return 'Language service not available';
}
